<template>
    <div v-if="activeSite">
        <h3 class="mb-4">
            Descargas
            <b-button
                v-if="isUserStudenTeacherOrBetter"
                class="ml-2"
                variant="primary"
                @click="onCreateDownloadFile()"
            >
                <b-icon-plus /> Agregar Archivo
            </b-button>
            <b-button
                v-if="isUserStudenTeacherOrBetter"
                class="ml-2"
                variant="primary"
                @click="onCreateHyperlink()"
            >
                <b-icon-plus /> Agregar Enlace
            </b-button>
            <b-button
                v-if="isUserStudenTeacherOrBetter"
                class="ml-2"
                variant="primary"
                @click="onCreateVideo()"
            >
                <b-icon-plus /> Agregar Video
            </b-button>
        </h3>

        <template v-if="fileDownloads || videos || links">
            <b-tabs active-nav-item-class="bg-primary text-white">
                <b-tab
                    v-for="(downloadFiles, downloadType) in fileDownloads"
                    :key="downloadType"
                    :title="downloadType"
                >
                    <b-list-group>
                        <b-list-group-item
                            v-for="file in downloadFiles"
                            :key="`download-${file.id}`"
                        >
                            <a
                                :href="file.downloadUrl"
                                target="_blank"
                            >
                                <h4 class="list-group-item-heading">{{ file.name }}</h4>
                            </a>
                            <h5 class="list-group-item-text">
                                {{ file.sizeKB }} KB - {{ file.clicks }} descargas.
                            </h5>
                            <h5
                                v-if="isUserStudenTeacherOrBetter"
                                class="list-group-item-text"
                            >
                                <b-button
                                    variant="danger"
                                    size="sm"
                                    class="ml-2"
                                    @click="onDeleteFile(file)"
                                >
                                    <b-icon-trash-fill />
                                </b-button>
                            </h5>
                        </b-list-group-item>
                    </b-list-group>
                </b-tab>

                <b-tab
                    v-if="links"
                    title="Enlaces"
                >
                    <b-list-group>
                        <b-list-group-item
                            v-for="link in links"
                            :key="`link-${link.id}`"
                        >
                            <a
                                :href="link.url"
                                target="_blank"
                            >
                                <h4 class="list-group-item-heading">{{ link.name }}</h4>
                            </a>
                            <h5
                                v-if="isUserStudenTeacherOrBetter"
                                class="list-group-item-text"
                            >
                                <b-button
                                    variant="danger"
                                    size="sm"
                                    class="ml-2"
                                    @click="onDeleteHyperlink(link)"
                                >
                                    <b-icon-trash-fill />
                                </b-button>
                            </h5>
                        </b-list-group-item>
                    </b-list-group>
                </b-tab>

                <b-tab
                    v-if="videos"
                    title="Videos"
                >
                    <b-list-group>
                        <b-list-group-item
                            v-for="video in videos"
                            :key="`video-${video.id}`"
                        >
                            <a
                                href=""
                                @click.prevent.stop="onDisplayVideo(video)"
                            >
                                <h4 class="list-group-item-heading">{{ video.name }}</h4>
                            </a>
                            <h5 class="list-group-item-text">
                                {{ video.clicks }} clicks
                            </h5>
                            <h5
                                v-if="isUserStudenTeacherOrBetter"
                                class="list-group-item-text"
                            >
                                <b-button
                                    variant="danger"
                                    size="sm"
                                    class="ml-2"
                                    @click="onDeleteVideo(video)"
                                >
                                    <b-icon-trash-fill />
                                </b-button>
                            </h5>
                        </b-list-group-item>
                    </b-list-group>
                </b-tab>
            </b-tabs>

        </template>
        <p v-else>No existen descargas o videos para este sitio web todavía.</p>

        <!-- Create Download File Modal -->
        <DownloadFileCreateFormModal v-if="isUserStudenTeacherOrBetter"/>

        <!-- Create Hyperlink Modal -->
        <HyperlinkCreateFormModal v-if="isUserStudenTeacherOrBetter"/>

        <!-- Create Video Modal -->
        <VideoCreateFormModal v-if="isUserStudenTeacherOrBetter"/>

        <!-- Display Video Modal -->
        <VideoDetailsModal />
    </div>
</template>

<script>
import DownloadFileCreateFormModal from './DownloadFileCreateFormModal'
import HyperlinkCreateFormModal from './HyperlinkCreateFormModal'
import VideoCreateFormModal from './VideoCreateFormModal'
import VideoDetailsModal from './VideoDetailsModal'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'SiteDownloads',
    components: {
        DownloadFileCreateFormModal,
        HyperlinkCreateFormModal,
        VideoCreateFormModal,
        VideoDetailsModal
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject'
        ]),
        ...mapGetters({
            fileDownloads: 'getActiveSiteDownloadsByType',
            videos: 'getActiveSiteFormattedVideos',
            links: 'getActiveSiteFormattedLinks',
            isUserStudenTeacherOrBetter: 'isUserStudenTeacherOrBetter',
            getActiveSiteIdentifiers: 'getActiveSiteIdentifiers'
        })
    },
    methods: {
        ...mapActions([
            'deleteSiteHyperlink',
            'deleteSiteVideo',
            'deleteSiteDownloadFile',
            'readCourseSiteByAcademicPeriod'
        ]),
        onCreateDownloadFile () {
            this.$bvModal.show('modal-create-download-file')
        },
        onCreateHyperlink () {
            this.$bvModal.show('modal-create-download-link')
        },
        onCreateVideo () {
            this.$bvModal.show('modal-create-download-video')
        },
        onDisplayVideo (videoObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', videoObject)
            this.$bvModal.show('modal-details-video')
        },
        async onDeleteHyperlink (linkObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', linkObject)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el enlace.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDeleteHyperlink()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDeleteHyperlink () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, linkId: this.selectedCrudObject.id }
                await this.deleteSiteHyperlink(payloadData)
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.infoToast('El enlace ha sido eliminado exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el enlace, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        },
        async onDeleteVideo (videoObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', videoObject)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el video.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDeleteVideo()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDeleteVideo () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, videoId: this.selectedCrudObject.id }
                await this.deleteSiteVideo(payloadData)
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.infoToast('El video ha sido eliminado exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el video, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        },
        async onDeleteFile (fileObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', fileObject)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el archivo descargable.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDeleteFile()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDeleteFile () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, fileId: this.selectedCrudObject.id }
                await this.deleteSiteDownloadFile(payloadData)
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.infoToast('El archivo descargable ha sido eliminado exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el archivo descargable, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    }
}
</script>
